import {
  Bbox,
  BboxCanvas,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import { DocumentLink } from '@/modules/tools/bankruptcy/components/CasePage/DocumentLink'
import type {
  CaseDocument,
  PageBbox,
  Source,
} from '@/modules/tools/bankruptcy/stores/types'
import { useDialogActions, useDialogData, useDialogIsOpen } from '@/stores'

export const SOURCE_VIEWER_DIALOG_ID = 'bankruptcy-source-viewer'
const boxStyles: Record<Source['precision'], string> = {
  value: 'stroke-brand fill-brand/10',
  region: 'stroke-amber-500 fill-amber-500/10',
}

export interface SourceViewerPayload {
  source: Source
  document: CaseDocument
  page: PageBbox
  label: string
}

export const SourceViewer = () => {
  const open = useDialogIsOpen(SOURCE_VIEWER_DIALOG_ID)
  const { closeDialog } = useDialogActions()
  const data = useDialogData() as SourceViewerPayload | undefined

  return (
    <Dialog open={open} onOpenChange={(next) => !next && closeDialog()}>
      <DialogContent className="max-w-3xl">
        {data?.source && data.page && (
          <>
            <DialogHeader>
              <DialogTitle className="pr-8 leading-snug">
                {data.label}
              </DialogTitle>
              <DialogDescription>
                File <DocumentLink document={data.document} /> · Page{' '}
                {data.source.page + 1}
                {data.source.precision === 'region' &&
                  ' · approximate area — the exact figure could not be pinned'}
              </DialogDescription>
            </DialogHeader>
            <BboxCanvas
              key={data.page.previewUrl}
              bbox={data.page.bbox}
              preview={data.page.previewUrl}
              ariaLabel={`${data.label} on page ${data.source.page + 1}`}
              className="max-h-[70vh] overflow-auto rounded-lg border bg-white"
            >
              <Bbox
                aria-hidden
                bbox={data.source.bbox}
                className={boxStyles[data.source.precision]}
                strokeWidth={4}
                strokeDasharray={
                  data.source.precision === 'region' ? 15 : undefined
                }
                rx={6}
              />
            </BboxCanvas>
          </>
        )}
      </DialogContent>
    </Dialog>
  )
}
